import React from 'react';
import {Helmet} from 'react-helmet';
import useSiteMeta from '../../query/useSiteMeta';

const SEO = ({description, meta, title}) => {
  const {
    siteName,
    langDefault,
    titleDefault,
    descriptionDefault,
  } = useSiteMeta();
  const metaTitle = title || titleDefault;
  const metaDescription = description || descriptionDefault;
  const _lang = langDefault || 'en';
  return (
    <Helmet
      htmlAttributes={{
        lang: _lang,
      }}
      title={metaTitle}
      titleTemplate={`%s | ${siteName}`}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: metaTitle,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        // {
        //   name: `twitter:creator`,
        //   content: author,
        // },
        {
          name: `twitter:title`,
          content: metaTitle,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
      ].concat(meta)}
    >
      <link rel="dns-prefetch" href="//fonts.googleapis.com" />
      <link rel="dns-prefetch" href="//cdn.snipcart.com/" />
      <link
        rel="apple-touch-icon"
        sizes="180x180"
        href="/apple-touch-icon.png"
      />
      <link
        rel="icon"
        type="image/png"
        sizes="32x32"
        href="/favicon-32x32.png"
      />
      <link
        rel="icon"
        type="image/png"
        sizes="16x16"
        href="/favicon-16x16.png"
      />
      <link rel="manifest" href="/site.webmanifest" />
    </Helmet>
  );
};
// <link
//   href="https://fonts.googleapis.com/css?family=Open+Sans:400,600&display=swap"
//   rel="stylesheet"
// />

SEO.defaultProps = {
  meta: [],
  description: ``,
};

export default SEO;
